import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import VL09reversegoodsmovement01 from './../workinstructions/images/VL09-reversegoodsmovement01.png';
import VL09reversegoodsmovement02 from './../workinstructions/images/VL09-reversegoodsmovement02.png';

class VL09 extends React.Component {
	async componentDidMount() {
    document.title = "Nokia MN Outbound";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>VL09</PanelHeader>
					<PanelBody>
					<h2>Reverse Goods Movement</h2>
						<h2>Un-PGI/ Reverse a delivery</h2>
						<p>Modifiation in a PGI-ed delivery can only bedone after the PGI has been reversed <br/>
						Use VL09 =&gt; fill in delivery-nr =&gt; Execute F8 <br/ >				

							<p> <img src={VL09reversegoodsmovement01} alt="VL09 fill in the delivery-nr" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							<p> <img src={VL09reversegoodsmovement02} alt="after execute VL09" style={{ maxWidth: '100%', height: 'auto' }} /> </p>

						</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; Nov 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default VL09;
